<template>
  <div>
    <Header></Header>
    <!-- <ModelBrandCreation></ModelBrandCreation>
    <ModelUsersValue></ModelUsersValue>
    <ModelSecurityTechnology></ModelSecurityTechnology>
    <BrandLifestyle :videoSrc="videoUrl"></BrandLifestyle> -->
    <ModelBrandPage></ModelBrandPage>
    <Footer></Footer>
  </div>
</template>
<script>
// import ModelBrandCreation from "../../components/brand/modelBrandCreation";
// import ModelUsersValue from "../../components/brand/modelUsersValue.vue";
// import ModelSecurityTechnology from "../../components/modelSecurityTechnology";
// import BrandLifestyle from "../../components/Lifestyle/brandLifestyle.vue";
import ModelBrandPage from "../../components/brand/modelBrandPage";
export default {
  data() {
    return {
      videoUrl:
        "https://res.gwm.com.cn/2021/04/30/1804281_151_6d45da9877da91b676a9b6b323a67b10_mocca_10s.mp4",
    };
  },
  components: {
    // ModelSecurityTechnology,
    // ModelBrandCreation,
    // ModelUsersValue,
    // BrandLifestyle,
    ModelBrandPage
  },
  mounted() {

  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
</style>